module.exports = "/img/integrations/botengine-app-logo.png?e5e4bcf6e9d1725032dca6d003ce09c5";